import './real-estate-listing-details.css';

import type { FunctionComponent } from 'react';

import { BedroomIcon } from '../../icons/bedroom-icon';
import { BathroomIcon } from '../../icons/bathroom-icon';
import { FloorplanIcon } from '../../icons/floor-plan-icon';
import { getFormattedCurrency } from '../../libs/format-currency';

interface Props {
  details: any;
}

export const RealEstateListingDetails: FunctionComponent<Props> = ({ details }) => {
  const {
    property_address,
    property_price,
    listing_title,
  } = details;

  return (
    <div className="details-container">
      <div className="listing-content">
        <h2>{listing_title}</h2>
        <p>{property_address}</p>
        {/* <div className="details">
          <div className="detail_item">
            <FloorplanIcon /> {property_square_feet.replace('sq ft', 'ft²')}
          </div>
          <div className="detail_item">
            <BathroomIcon /> {property_bathrooms}
          </div>
          <div className="detail_item">
            <BedroomIcon /> {property_bedrooms}
          </div>
        </div> */}

        {/* <p className="description">{listing_description}</p> */}

        <p className="price">
          {property_price || property_price !== 0 ? property_price + ' ₺' : 'Ücretsiz'}
        </p>
      </div>
    </div>
  );
};
